import { useEffect, useState } from 'react';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled
          ? 'bg-background-950/80 backdrop-blur-xl border-b border-background-200/20'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-6 md:px-10 lg:px-16 flex items-center justify-between h-16 md:h-20">
        {/* Logo */}
        <a href="/" className="flex items-center gap-2 shrink-0">
          <img
            src="/images/logo.png"
            alt="MARKER Logo"
            className="w-8 h-8 rounded-lg object-contain"
          />
          <span className="text-foreground-50 font-bold text-lg tracking-tight">MARKER</span>
        </a>

        {/* Center Nav */}
        <div className="hidden md:flex items-center gap-8">
          <a href="#how-it-works" className="text-foreground-400 text-sm font-medium hover:text-foreground-50 transition-colors whitespace-nowrap">
            How it works
          </a>
          <a href="#for-bars" className="text-foreground-400 text-sm font-medium hover:text-foreground-50 transition-colors whitespace-nowrap">
            For bars
          </a>
          <a href="#about" className="text-foreground-400 text-sm font-medium hover:text-foreground-50 transition-colors whitespace-nowrap">
            About Us
          </a>
        </div>

        {/* Right Actions */}
        <div className="flex items-center gap-4 shrink-0">
          <a
            href="#download"
            className="hidden sm:inline-flex items-center gap-2 px-5 py-2.5 bg-primary-500 text-background-950 text-sm font-bold rounded-lg hover:bg-primary-400 transition-colors whitespace-nowrap"
          >
            Get MARKER
          </a>
          <button className="md:hidden text-foreground-50 w-8 h-8 flex items-center justify-center">
            <i className="ri-menu-4-line text-xl" />
          </button>
        </div>
      </div>
    </nav>
  );
}